import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private router: Router) {}

  endSession(): void {
    this.router.navigate(['/login']).then();
  }
}
